// extracted by mini-css-extract-plugin
module.exports = {"pair":"get-orders-columns-list_pair__wbPiw","yourOrder":"get-orders-columns-list_yourOrder__uEdy9"};